module.exports = __webpack_public_path__ + "static/media/top-element-orange.e52a160a.svg";